import React, { Component } from 'react';
import './Home.css';


import {connect} from "react-redux";
import NavBar from '../../shared/NavBar';


import Notifications, {notify} from 'react-notify-toast';
import Reorder, {
    reorder
} from 'react-reorder';

class Home extends Component {

    constructor(props) {
        super(props);

        console.log(this.props);
        this.state = {
            teams: [],
            team: [],
            selectedTeam: 0,
            loading: true
        };


        this.onReorder = this.onReorder.bind(this);
        this.getTeamInfo = this.getTeamInfo.bind(this);
        this.updateAppointments = this.updateAppointments.bind(this);
    }

    componentDidMount(){

        fetch('https://dev.iondeveloper.com/api/setter/system/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method":"get_all_teams"
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {


            if (this.props.state.user.permission === 'manager'){


                this.setState({loading: true});
                fetch('https://dev.iondeveloper.com/api/setter/system/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
                    method: 'post',
                    body: JSON.stringify(
                        {
                            "method":"get_team_members",
                            "account_id": this.props.state.user.team_id
                        }
                    )
                }).then(function(response) {
                    return response.json();
                }).then(function(data) {

                    this.setState({
                        team: data.data,
                        loading: false
                    });

                }.bind(this));

                this.setState({selectedTeam: this.props.state.user.team_id});

            } else {

                this.setState({
                    teams: data.data,
                    selectedTeam: data.data[0]['account_id']
                });


                fetch('https://dev.iondeveloper.com/api/setter/system/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
                    method: 'post',
                    body: JSON.stringify(
                        {
                            "method":"get_team_members",
                            "account_id": data.data[0]['account_id']
                        }
                    )
                }).then(function(response) {
                    return response.json();
                }).then(function(data) {

                    this.setState({
                        team: data.data,
                        loading: false
                    });

                }.bind(this));


            }

        }.bind(this));

    }

    getTeamInfo(event){


        this.setState({loading: true});
        fetch('https://dev.iondeveloper.com/api/setter/system/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method":"get_team_members",
                    "account_id": event.target.value
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            this.setState({
                team: data.data,
                loading: false
            });

        }.bind(this));


        this.setState({selectedTeam: event.target.value});
    }

    updateAppointments(event){

        // this.state.team[event.target.name]['max_appointments'] = event.target.value;
        this.setState({
            team: this.state.team
        });

        fetch('https://dev.iondeveloper.com/api/setter/system/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method":"update_rep_priority",
                    "rep_data": JSON.stringify(this.state.team)
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            notify.show('New Max Appointments has been saved!', 'success');


        });

    }



    onReorder (event, previousIndex, nextIndex, fromId, toId) {

        this.setState({
            team: reorder(this.state.team, previousIndex, nextIndex),
        });

        fetch('https://dev.iondeveloper.com/api/setter/system/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method":"update_rep_priority",
                    "rep_data": JSON.stringify(this.state.team)
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            notify.show('New team priority has been saved!', 'success');


        });


    }





    render() {

        if (this.props.state.loggedIn === false){
            return (<div></div>);
        }
        else {



        const numbers = this.state.team;
        const listItems = numbers.map((item, index) =>
            <li className="listItems" key={index}>
                <div className="profile-image">
                    <img  src={item.profile} alt=""/>
                </div>
                <div className="list-name">
                    {index + 1} | {item.fname} {item.lname}
                </div>
                <div className="list-body">
                    Max Appointments: <input className="appointments-con" name={index} onChange={this.updateAppointments} type="number" value={item.max_appointments}/>
                </div>

            </li>
        );


        const teams = this.state.teams.map((item, index) =>
            <option key={index} value={item.account_id}>{item.name}</option>
        );
        let loader = [];
        if (this.state.loading === true){
            loader.push(
                <div key={0} className="loader">Loading...</div>
            );
        }



            if (this.props.state.user.permission === 'admin') {
                return (
                    <div className="login-bg-color">
                        <NavBar />

                        <div className="container">
                            <Notifications />
                            <div className="priority-widget">
                                <h5>Rep Appointment Priority</h5>
                                <select value={this.state.selectedTeam} onChange={this.getTeamInfo} selected="none"
                                        className="select-box">
                                    {teams}
                                </select>
                                <hr/>
                                <div>
                                    {loader}
                                </div>
                                <Reorder
                                    reorderId="my-list" // Unique ID that is used internally to track this list (required)
                                    reorderGroup="reorder-group" // A group ID that allows items to be dragged between lists of the same group (optional)
                                    component="ul" // Tag name or Component to be used for the wrapping element (optional), defaults to 'div'
                                    placeholderClassName="placeholder" // Class name to be applied to placeholder elements (optional), defaults to 'placeholder'
                                    draggedClassName="dragged" // Class name to be applied to dragged elements (optional), defaults to 'dragged'
                                    lock="horizontal" // Lock the dragging direction (optional): vertical, horizontal (do not use with groups)
                                    touchHoldTime={500} // Hold time before dragging begins on touch devices (optional), defaults to holdTime
                                    mouseHoldTime={200} // Hold time before dragging begins with mouse (optional), defaults to holdTime
                                    onReorder={this.onReorder.bind(this)} // Callback when an item is dropped (you will need this to update your state)
                                    autoScroll={true} // Enable auto-scrolling when the pointer is close to the edge of the Reorder component (optional), defaults to true
                                    disabled={false} // Disable reordering (optional), defaults to false
                                    disableContextMenus={true} // Disable context menus when holding on touch devices (optional), defaults to true
                                    placeholder={
                                        <div className="custom-placeholder"/> // Custom placeholder element (optional), defaults to clone of dragged element
                                    }
                                >

                                    {listItems}
                                </Reorder>
                            </div>

                        </div>
                    </div>
                );
            } else if (this.props.state.user.permission === 'manager') {
                return (
                    <div className="login-bg-color">
                        <NavBar />

                        <div className="container">
                            <Notifications />
                            <div className="priority-widget">
                                <h5>Rep Appointment Priority</h5>
                                <hr/>
                                <div>
                                    {loader}
                                </div>
                                <Reorder
                                    reorderId="my-list" // Unique ID that is used internally to track this list (required)
                                    reorderGroup="reorder-group" // A group ID that allows items to be dragged between lists of the same group (optional)
                                    component="ul" // Tag name or Component to be used for the wrapping element (optional), defaults to 'div'
                                    placeholderClassName="placeholder" // Class name to be applied to placeholder elements (optional), defaults to 'placeholder'
                                    draggedClassName="dragged" // Class name to be applied to dragged elements (optional), defaults to 'dragged'
                                    lock="horizontal" // Lock the dragging direction (optional): vertical, horizontal (do not use with groups)
                                    touchHoldTime={500} // Hold time before dragging begins on touch devices (optional), defaults to holdTime
                                    mouseHoldTime={200} // Hold time before dragging begins with mouse (optional), defaults to holdTime
                                    onReorder={this.onReorder.bind(this)} // Callback when an item is dropped (you will need this to update your state)
                                    autoScroll={true} // Enable auto-scrolling when the pointer is close to the edge of the Reorder component (optional), defaults to true
                                    disabled={false} // Disable reordering (optional), defaults to false
                                    disableContextMenus={true} // Disable context menus when holding on touch devices (optional), defaults to true
                                    placeholder={
                                        <div className="custom-placeholder"/> // Custom placeholder element (optional), defaults to clone of dragged element
                                    }
                                >

                                    {listItems}
                                </Reorder>
                            </div>

                        </div>
                    </div>
                );

            } else {

                return(
                    <div>

                    </div>
                );

            }

        }
    }
}

function mapStateToProps(state) {
    return {
        state: state
    };
}

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/components/pages/Home/Home.js